import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, map, switchMap} from 'rxjs/operators';
import {debug} from '../../../rxjs-operators';
import {error} from '../actions/toasts';
import {ArrayResponse} from '../models/array-response';
import {SendBackResult} from '../models/send-back-result';
import {BaseEffect} from './base.effect';
import {
  LoadSubscriptionsLinkContractAction, LoadSubscriptionsLinkContractFailAction,
  LoadSubscriptionsLinkContractSuccessAction,
  subscriptionsLinkContractActionTypes
} from '../actions/subscription-link-contract';
import {ContractLinkServiceService} from '../services/contract-link.service';
import {ContractLinkSummaries} from '../models/contract-link';
import {L10nTranslationService} from 'angular-l10n';

@Injectable()
export class SubscriptionsLinkContractEffect extends BaseEffect {

  load$ = createEffect(() => { return this.actions$.pipe(
    ofType(subscriptionsLinkContractActionTypes.LOAD),
    debug('Load subscriptions action received.'),
    switchMap((data: LoadSubscriptionsLinkContractAction) => this.contractLinkServiceService.loadSubscriptions(data.payload).pipe(
      map((result: SendBackResult<ArrayResponse<ContractLinkSummaries>>) => new LoadSubscriptionsLinkContractSuccessAction(result.data.array)),
      catchError(res => this.catchResponseError(res)),
    )))
  });


  loadFail$ = createEffect(() => { return this.actions$.pipe(
    ofType(subscriptionsLinkContractActionTypes.LOAD_FAIL),
    debug('A server error occurred while retrieving subscriptions list.'),
    map((action: LoadSubscriptionsLinkContractFailAction) =>
      error(this.translation.translate('SUBSCRIPTIONS_LOAD_ERROR') + '  ' + action.payload, this.translation.translate('TOAST_ERROR_TITLE'))))
  });

  constructor(private actions$: Actions,
              private translation: L10nTranslationService,
              private contractLinkServiceService: ContractLinkServiceService,
              router: Router) {
    super(router);
  }

  protected handleUnhandledError = (response) => {
    return new LoadSubscriptionsLinkContractFailAction(response['error'].message);
  }

  protected handleGoneError = (response) => {
    return new LoadSubscriptionsLinkContractFailAction(response['error'].message);
  }
}
